<template>
	<div class="mr-12 connections width-100 height-100">
		<div class="width-100 display-flex flex-row flex-align-center flex-justify-space-between pt-7 pr-6 pb-4">
			<div>
				<div class="title-text">Destinations</div>
				<div class="description-text">
					Add custom tracking events and data destinations to your workflows to analyze your features' usage
				</div>
			</div>
			<div>
				<AnemicButton @click="showDialog" class="new-button"> Add destination </AnemicButton>
			</div>
		</div>
		<template>
			<Col v-if="isLoading" class="flex-centerize height-100">
				<AppLoader class="mt-4" size="18px" color="#101840" />
			</Col>
			<div v-else-if="isNoResults" class="height-100 flex-centerize">
				<h2 class="reg">No event destinations found</h2>
			</div>
			<div v-else class="overflow-y-auto display-flex flex-column width-100 px-6 list-container">
				<SettingsTable :sourceList="analyticsConnections">
					<template v-slot:item="{ item }">
						<SettingsTrackingListItem
							:key="item.id"
							class="mb-2 px-2"
							:connectionData="item"
							:src="useAnalyticsProviders[item.analytics_provider]?.icon"
							:alwaysShowProjectChip="isVirtualProject"
						/>
					</template>
				</SettingsTable>
			</div>
		</template>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import SettingsTrackingListItem from '@/components/Settings/SettingsTrackingListItem.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { fetchAnalyticsConfigurations, fetchAnalyticsProviders } from '@/store/modules/analyticsProvider/actions';
import { useAnalyticsConfigurations, useAnalyticsProviders } from '@/store/modules/analyticsProvider/getters';
import { selectedProjectId } from '@/store/modules/selectedProject/getters';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { VIRTUAL_PROJECT_IDS } from '@/utils/projects.const';
import SettingsTable from '@/views/settings/SettingsTable';

export default {
	name: 'TrackingConnections',
	props: {
		preselectApp: { type: Object },
		connectionsBySections: { type: Array },
		currentProjectId: { type: [String, Number] },
	},
	components: {
		SettingsTable,
		SettingsTrackingListItem,
	},
	computed: {
		...mapGettersShorthand({ useAnalyticsConfigurations, useAnalyticsProviders }),
		...mapGetters([selectedProjectId.fullPath]),
		analyticsConnections() {
			return this.useAnalyticsConfigurations;
		},
		isNoResults() {
			return this.analyticsConnections.length === 0;
		},
		selectedProjectId() {
			return this[selectedProjectId.fullPath];
		},
		isVirtualProject() {
			return VIRTUAL_PROJECT_IDS.includes(this.selectedProjectId);
		},
	},
	methods: {
		...mapActionsShorthand({ fetchAnalyticsConfigurations, fetchAnalyticsProviders }),
		showDialog() {
			AppDialogManagerService.openAnalyticsEventTrackingSettingsDialog({});
		},
	},
	async mounted() {
		this.isLoading = true;
		try {
			await this.fetchAnalyticsConfigurations();
			await this.fetchAnalyticsProviders();
		} catch (error) {
			this.$toast.error('Error while loading connections');
		} finally {
			this.isLoading = false;
		}
	},
	data: () => ({
		isLoading: false,
	}),
};
</script>

<style scoped lang="scss">
.connections {
	height: 100%;
	padding-bottom: 150px;
}
.new-button {
	width: 145px !important;
	padding: 0px !important;
	height: 45px !important;
	border-radius: 8px !important;
	background-color: #6762f0 !important;

	color: var(--bg-color);
	font-size: 14px !important;
	font-weight: normal !important;
}
.title-text {
	font-size: 20px;
	letter-spacing: 0px;
	text-align: left;
	color: var(--primary-font-color);
}
.description-text {
	font-size: 14px;
	color: var(--Colors-Neutral-Text-colorTextSecondary, #646e87);
	font-weight: 300;
	text-align: left;
	letter-spacing: 0px;
}
.list-container {
	height: 100%;
}
</style>
